<template>
  <div class="nav-header">
    <div class="container">
      <!-- logo -->
      <div class="n-logo">
        <div class="logo-container">
          <img src="/imgs/logo.png" alt="首都电影院" class="logo-img">
          <div class="logo-text">
            <div class="logo-title">首都电影院</div>
            <div class="logo-subtitle">CAPITAL CINEMA</div>
          </div>
        </div>
      </div>
      
      <!-- 导航 -->
      <div class="n-list">
        <a href="javascript:;" class="nav-item " @click="gohome()">
          <i class="iconfont icon-home"></i>
          <span>网站首页</span>
        </a>
        <a href="javascript:;" class="nav-item" @click="goAc2()">
          <i class="iconfont icon-news"></i>
          <span>行业资讯</span>
        </a>
        <a href="javascript:;" class="nav-item" @click="goXy()">
          <i class="iconfont icon-news"></i>
          <span>用户协议</span>
        </a>
        <a href="javascript:;" class="nav-item" @click="goInfo()">
          <i class="iconfont icon-about"></i>
          <span>关于我们</span>
        </a>
      </div>
      
      <!-- 登录注册 -->
      <div class="n-login">
        <span class="login-btn" @click="goLogin()" v-show="this.LoggedShow">
          <i class="iconfont icon-denglu"></i>
          登录
        </span>
        <span class="register-btn" @click="goRegister()" v-show="this.LoggedShow">
          <i class="iconfont icon-zhuce"></i>
          注册
        </span>
        
        <!-- 用户名 -->
        <span class="user-info" v-show="!this.LoggedShow" v-text="this.nv_user.Username">
          <i class="iconfont icon-user"></i>
        </span>

        <!-- 退出登录 -->
        <span class="logout-btn" @click="tolg()" v-show="!this.LoggedShow">
          <i class="iconfont icon-tuichudenglu"></i>
          退出登录
        </span>
      </div>
    </div>
    
    <!-- 电影胶片装饰 -->
    <div class="film-strip"></div>
  </div>
</template>

<script>
export default {
  name: "nav-header",
  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.logged();
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      window.localStorage.setItem("state", "10");
      this.LoggedShow = true;
      location.reload();
      // this.$forceUpdate()
    },
    // 跳转最新文章
    goAc1() {
      this.$router.push("/ac1");
    },
    // 跳转行业资讯
    goAc2() {
      this.$router.push("/ac2");
    },
    // 跳转独加新闻
    goAc3() {
      this.$router.push("/ac3");
    },
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/xy");
    },
    gohome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.nav-header {
  width: 100%;
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, #0c0c0c 0%, #1a1a1a 50%, #0c0c0c 100%);
  z-index: 10;
  border-bottom: 3px solid #ffd700;
  box-shadow: 0 5px 25px rgba(255, 215, 0, 0.3);

  .container {
    height: 100%;
    @include flex();
    padding: 0 40px;
    position: relative;

    // logo
    .n-logo {
      width: 300px;
      height: 100%;
      .logo-container {
        display: flex;
        align-items: center;
        height: 100%;
        .logo-img {
          height: 60px;
          width: auto;
          margin-right: 15px;
          filter: drop-shadow(0 0 5px rgba(255, 215, 0, 0.5));
        }
        .logo-text {
          .logo-title {
            font-size: 24px;
            font-weight: bold;
            color: #ffd700;
            text-shadow: 0 0 10px rgba(255, 215, 0, 0.7);
            letter-spacing: 2px;
          }
          .logo-subtitle {
            font-size: 12px;
            color: #fff;
            letter-spacing: 3px;
            margin-top: 5px;
          }
        }
      }
    }

    // 导航
    .n-list {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 40px;

      .nav-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
        padding: 10px 15px;
        border-radius: 5px;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;

        i {
          font-size: 24px;
          color: #fff;
          margin-bottom: 5px;
          transition: all 0.3s ease;
        }

        span {
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          letter-spacing: 1px;
          transition: all 0.3s ease;
        }

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 215, 0, 0.4), transparent);
          transition: left 0.5s ease;
        }

        &:hover {
          background: rgba(255, 215, 0, 0.1);
          transform: translateY(-2px);
          
          i, span {
            color: #ffd700;
          }

          &::before {
            left: 100%;
          }
        }

        &.active {
          background: rgba(255, 215, 0, 0.2);
          border: 1px solid #ffd700;
          
          i, span {
            color: #ffd700;
          }
        }
      }
    }

    // 登录注册
    .n-login {
      display: flex;
      align-items: center;
      gap: 20px;

      .login-btn, .register-btn, .logout-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 20px;
        border-radius: 25px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid transparent;
      }

      .login-btn {
        color: #fff;
        background: rgba(255, 255, 255, 0.1);
        
        &:hover {
          background: rgba(255, 215, 0, 0.2);
          border-color: #ffd700;
          color: #ffd700;
        }
      }

      .register-btn {
        color: #fff;
        background: linear-gradient(135deg, #ffd700, #ffed4e);
        color: #000;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(255, 215, 0, 0.4);
        }
      }

      .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 20px;
        background: rgba(255, 215, 0, 0.1);
        border-radius: 25px;
        color: #ffd700;
        font-weight: 500;
        border: 1px solid #ffd700;
      }

      .logout-btn {
        color: #fff;
        background: rgba(255, 255, 255, 0.1);
        
        &:hover {
          background: rgba(220, 53, 69, 0.2);
          border-color: #dc3545;
          color: #dc3545;
        }
      }
    }
  }

  // 电影胶片装饰
  .film-strip {
    position: absolute;
    // bottom: -10px;
    bottom: -6px;
    left: 0;
    width: 100%;
    height: 5px;
    background: repeating-linear-gradient(
      90deg,
      #000 0px,
      #000 10px,
      #ffd700 10px,
      #ffd700 20px,
      #000 20px,
      #000 30px
    );
    opacity: 0.7;
  }
}
</style>